// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".faq-question").forEach(button => {
//     button.addEventListener("click", () => {
//       const item = button.closest(".faq-item");
//       const answer = item.querySelector(".faq-answer");

//       item.classList.toggle("active");

//       if (answer.style.display === "block") {
//         answer.style.display = "none";
//       } else {
//         answer.style.display = "block";
//       }
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-question").forEach(button => {
    button.addEventListener("click", () => {
      const item = button.closest(".faq-item");
      const answer = item.querySelector(".faq-answer");

      // Toggle active state
      item.classList.toggle("active");

      if (item.classList.contains("active")) {
        // OPEN
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        // CLOSE
        answer.style.maxHeight = "0px";
      }
    });
  });
});

